import React from "react";
import styled from "styled-components";
import { ACSS, P } from "@upsolve/ui";

import getMyUpsolveEntryUrl from "../Links/getMyUpsolveEntryUrl";
import { MyUpsolveLink } from "../Links/MyUpsolveLink";
import trackComponentAction from "../analytics/trackComponentAction";
import timeToRead from "../Contentful/timeToRead";

const trackingProps = {
  componentName: "UpsolveTextBio",
  componentVersion: 0,
};

/**
 * UpsolveTextBio
 * - v0: Lots of text. Bankruptcy, community, Forbes, no credit card etc.
 * - v1: Make it look like a paragraph, less like a disclaimer. Rmv bk myths text
 *
 * @component
 * @version 0
 */
const UpsolveTextBio = ({ wordCount, ...props }) => {
  return (
    <StyledUpsolveTextBio>
      <P>
        <b>
          {timeToRead(wordCount) ? (
            <>
              <u>{timeToRead(wordCount)}</u> •{" "}
            </>
          ) : null}
          Upsolve is a nonprofit tool that helps you file bankruptcy for free.
        </b>{" "}
        Think TurboTax for bankruptcy. Get free education, customer support, and community. Featured in Forbes 4x and
        funded by institutions like Harvard University so we'll never ask you for a credit card.{" "}
        <MyUpsolveLink
          aria-busy="false"
          href={getMyUpsolveEntryUrl({
            triggeredByActionId: "upsolveTextBio.myUpsolveNavigation",
            contentGroup: props.contentGroup,
          })}
          onClick={() =>
            trackComponentAction({
              ...trackingProps,
              actionId: "upsolveTextBio.myUpsolveNavigation",
              actionMethod: "click",
            })
          }
        >
          <u>Explore our free tool</u>
        </MyUpsolveLink>
      </P>
    </StyledUpsolveTextBio>
  );
};

const StyledUpsolveTextBio = styled.span`
  margin: 1em 0;
  label {
    font-size: 11px;
    font-weight: 500;
    color: ${(props) => props.theme.colors.brand[500]};
  }
  p {
    margin: 0;
    font-size: 14px;
    line-height: 150%;
    color: ${(props) => props.theme.colors.gray[700]};
  }
  span {
    ${ACSS}
    text-decoration: underline;
    &:hover {
      cursor: pointer;
    }
  }
  @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
    margin: 1em 0;
  }
`;

export default UpsolveTextBio;
